var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.wizardMode
        ? _c(
            "v-alert",
            {
              staticClass: "ma-0 pa-2",
              attrs: {
                mode: "fade",
                color: "warning",
                icon: "warning",
                outline: "",
                value: !_vm.hasMadeSelection,
              },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                !_vm.hasSelectedAnalyte && !_vm.hasSelectedStation
                  ? _c("div", [
                      _vm._v("\n        Select an "),
                      _c("strong", [_vm._v("analyte")]),
                      _vm._v(" and a "),
                      _c("strong", [_vm._v("station")]),
                      _vm._v(" to download.\n      "),
                    ])
                  : !_vm.hasSelectedAnalyte
                  ? _c("div", [
                      _vm._v("\n        Select an "),
                      _c("strong", [_vm._v("analyte")]),
                      _vm._v(" to download.\n      "),
                    ])
                  : !_vm.hasSelectedStation
                  ? _c("div", [
                      _vm._v("\n        Select a "),
                      _c("strong", [_vm._v("station")]),
                      _vm._v(" to download.\n      "),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.wizardMode
        ? _c(
            "v-alert",
            {
              staticClass: "ma-0 pa-2",
              attrs: {
                mode: "fade",
                color: "info",
                icon: "info",
                outline: "",
                value: _vm.hasUnsavedChanges,
              },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                !_vm.hasQuery
                  ? _c("div", [
                      _vm._v("\n        Your query is not saved yet.\n      "),
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n        Your changes have not been saved yet.\n        "
                      ),
                      _vm.mustSaveMissingParams
                        ? _c("span", [
                            _vm._v(
                              " The missing parameters are removed after saving. "
                            ),
                          ])
                        : _vm._e(),
                    ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          staticClass: "ma-0 pa-2",
          attrs: {
            mode: "fade",
            color: "warning",
            icon: "warning",
            outline: "",
            value: _vm.hasMissingParams,
          },
        },
        [
          _c(
            "div",
            { staticClass: "primary--text" },
            [
              _vm._v(
                "\n      Some parameters could not be loaded and might be deprecated.\n      "
              ),
              _c(
                "v-btn",
                {
                  attrs: { small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("showMissingParams")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("Button.ViewDetails")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }